import React from 'react'
import {TimeValue} from "../../../../../gd/types/datetime"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view";

type State = {
    initialPropsValue   : any, // required to check if currentOption update needed on props changed
    currentValue        : any,
    showPopover         : boolean
}

const debug = false
// const debug = "FieldDatetime_FormElementView"

export default class FieldDatetime_FormElementView extends React.Component<FieldFormElementViewProps,State> {

    public previousValue        : any

    constructor(props:FieldFormElementViewProps) {
        super(props);

        const value = props.field.getViewValue(props.model)
        debug && console.log(debug, "constructor", value)

        this.state = {
            initialPropsValue   : value, // required to check if currentValue update needed on props changed
            currentValue        : value,
            showPopover         : false,
        }
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()
        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    onValueChange = (value:any) => {

        if(!value){
            this.setState({
                currentValue: null
            }, ()=>{
                this.props.onChange && this.props.onChange(null)
            })
            return
        }

        this.previousValue = this.state.currentValue;

        if(!!this.previousValue?.time){
            value.set("hour",  this.previousValue.time.hours())
            value.set("minute",  this.previousValue.time.minutes())
        }

        const newValue = {
            date: value,
            time: !! this.previousValue?.time ? value : null
        }

        this.setState({
                currentValue: newValue
            }, ()=>{
            this.props.onChange && this.props.onChange(newValue)
        })
    }

    onSelectTime = (value: Moment)=>{

        if(!value){
            this.setState({
                currentValue: {
                    date: this.state.currentValue.date,
                    time: null
                }
            }, ()=>{
                this.props.onChange && this.props.onChange(null)
            })
            return
        }

        this.previousValue = this.state.currentValue;

        let date = !!this.previousValue?.date ? this.previousValue.date : moment()

        date.set("hour", value.hours())
        date.set("minute", value.minutes())

        const newValue = {
            date: date,
            time: date
        }

        this.setState({
            currentValue: newValue
        }, ()=>{
            this.props.onChange && this.props.onChange(newValue)
        })
    }

    setValue = (value:TimeValue | null) => {

        if(!value) {
            this.props.onChange && this.props.onChange(null)
            return
        }

        const result: Moment = moment()
        result.hours(value.hours)
        result.minutes(value.minutes)
        result.seconds(0)
        result.milliseconds(0)

        // make it first (!) to update model and hidePopover will reRenbder(!)
        this.props.onChange && this.props.onChange(result)

        this.hidePopover()
    }

    resetValue = () => {
        this.hidePopover()
        this.onValueChange(null);
        this.props.onChange && this.props.onChange(null)
    }

    render() {
        const {field} = this.props

        const classes = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        })

        // need check value because of none
        if (this.state.currentValue?.date) {
            return (
                <field.components.FormValueNotEmpty className   = {classes}
                                                    field       = {field}
                                                    onReset     = {this.resetValue}
                                                    options     = {this.props.options}
                                                    value       = {this.state.currentValue}
                                                    disabled    = {this.props.disabled}
                                                    onClick     = {this.showPopover}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} value={this.state.currentValue} parent={this} />}
                </field.components.FormValueNotEmpty>
            )
        } else {
            return (
                <field.components.FormValueEmpty className  = {classes}
                                                 field      = {field}
                                                 options    = {this.props.options}
                                                 onClick    = {this.showPopover}
                                                 disabled   = {this.props.disabled}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} value={this.state.currentValue} parent={this} />}
                </field.components.FormValueEmpty>
            )
        }
    }
}
